// extracted by mini-css-extract-plugin
module.exports = {"container":"table_container__2vKv2","empty":"table_empty__Aoe_A"};